import { type Messages } from "./interfaces/messages";
import { Advisory } from '@ca.vmedia.tv/swagger-api';
import { domain } from "@ca.vmedia.tv/domains";
import {AppConstants} from "@/common";

const messages: Messages = {
    test: "Hello, World!",
    okButton: "Ok",
    backButton: "Back",
    error: "Error",
    errorBtn: "Exit now",
    notImplemented: "Coming Soon...",
    appNameVmedia: "VMedia",
    appNameFizzTV: "FizzTV",
    appNameRiverTV: "RiverTV",
    appNameFreedom: "Freedom",
    somethingWentWrong: "Something went wrong. Please try again later.",
    time:{
        shortHour: 'h',
        shortMinute: 'min',
        shortSecond: 'sec'
    },
    login: {
        signin: "Sign In",
        accessAsGuest: "Guest mode",
        forgotPassword: "Forgot password?",
        next: "Next",
        visit: "Visit",
        password: "Password",
        enterPassword: "Enter Password",
        username: "Username",
        enterUsername: "Enter Username",
        usernameVmedia: "Username  (ex: 399000000000)",
        usernameRiver: "Username (ex: 416000000000)",
        usernameFizzTV: "Username (ex: 192000000000)",
        usernameFreedom: "Username (ex: 192000000000)",
        enterCredentials:
            "Please enter your {publisher} username and password.",
        getFreeTrial: "Get Free Trial",
        switchAccount: "Switch account",
        errors: {
            invalidCredentials: "Wrong credentials provided",
            invalidLocation: "Service is not available at your location",
            other: "Something went wrong on the server",
            networkProblem: "Something went wrong on the server",
            noSubscriptions: "Sorry, but you don't have an active subscription",
            notAvailable: "Not available"
        },
        restorePasswordUrl: {
            RiverTV: "https://rivertv.ca/forgot/password",
            VMedia: "https://www.vmedia.ca/en/support/password/forgot",
            Freedom: "https://www.vmedia.ca/en/support/password/forgot",
            FizzTV: "https://fizztv.ca/forgot/password"
        },
        forgot: {
            resetPassword: "Reset password",
            visit: "Visit:",
            or: "OR",
            scan: "Scan the QR code with your mobile device camera",
        },
        okta: {
            tokenError: {
                title: "Now that’s embarrassing",
                text: "The connection failed. Let’s give it another shot, shall we?",
                button: "OK",
            },
            serverError: {
                title: "There was an error",
                text: "The system experienced a little glitch. Please try again",
                button: "OK",
            },
            FizzTV: {
                title: "To connect this device to your Fizz TV plan:",
                goToWebsite: "From any browser, visit:",
                authCode: "Enter this activation code:",
                timer: "This code expires in",
                or: "OR",
                scan: "Using the camera on your mobile phone, scan this QR code:",
                footnote: "This page will close automatically once this device is successfully connected.",
                button: "Get a new code"
            },
            Freedom: {
                footnote: "This page will close automatically following successful activation.",
            }
        },
        signIn: {
            title: "To sign in and activate this device, from any browser",
            enterCode: "Enter activation code",
            getNewCode: "GET A NEW CODE",
            expiredCode: "Code Expired",
            unavailable: "This sign in type is currently unavailable. Please select another sign in type, or try again"
        },
        welcome: {
            firstScreen: {
                title: "Hi! Let’s get started.",
                subtitle: "Don’t have a Fizz TV plan yet?",
                infoFirst: "Discover our online TV service: on demand and live TV in HD quality on the device you want, with the capability of five (5) simultaneous viewings and much more.",
                infoSecond: "Visit Fizz.ca/TV for all the details."
            },
            secondScreen: {
                title: "A few steps and you’ll be set:",
                firstStep: "Sign in.",
                secondStep: "Follow the instructions to connect this device to your Fizz TV plan.",
                thirdStep: "Watch to your heart’s content."
            }
        }
    },
    menu: {
        home: "Home",
        guide: "Guide",
        onDemand: "On Demand",
        settings: "",
        myTv: "My TV",
        search: "",
    },
    devmode: {
        title: "Developer Mode",
        apiEnvironment: {
            title: "API Environment",
            description: '',
            preview: "Preview",
            prod: "Production",
        },
        oktaEnvironment: {
            title: "Okta Environment",
            description: `By default will works only with production endpoints Preview Okta API OFF`,
            preview: "Preview",
            prod: "Production",
        },
        reset: {
            title: "Disabling Developer Mode",
            description: `If you turn off developer mode, all settings will return to their default values.`,
            button: "Disable"
        }
    },
    settings: {
        title: "Settings",
        navigation: {
            account: "Account",
            subscription: "Manage Subscription",
            favorites: "Favourite Channels",
            parent: "Parental Control",
            privacy: "Privacy Policy",
            clearCache: "Clear cache",
            devmode: 'Developer Mode',
            about: {
                VMedia: "About Us",
                RiverTV: "About Us",
                FizzTV: "Unique philosophy",
                Freedom: "About Us"
            },
            player: "Player",
            softwareLicense: "Software License Agreement",
            freedomService: "Freedom TV service is powered by VMedia",
            help: "Help",
            language: "Language",
        },
        account: {
            title: "You are currently signed in as",
            guestUserName: "Guest",
            buttonSignIn: "SIGN IN",
            buttonSignOut: "SIGN OUT",
            modalText: "Are you sure you want to sign out?",
            modalPositive: "YES",
            modalNegative: "NO",
            modalClose: "CLOSE",
            modalRetry: "RETRY"
        },
        version: "Version {0}",
        privacyPolicy: {
            RiverTV: "https://rivertv.ca/devices/privacy-policy-dark",
            VMedia: "https://www.vmedia.ca/en/devices/support/privacy-policy",
            Freedom: "https://www.vmedia.ca/en/devices/support/privacy-policy",
            FizzTV: "https://www.vmedia.ca/en/devices/support/privacy-policy",
            qrTitle: "Scan the QR code with your mobile device camera",
        },
        aboutUs: {
            RiverTV: "https://rivertv.ca/devices/about-dark",
            VMedia: "https://www.vmedia.ca/en/devices/info/about",
            Freedom: "https://www.vmedia.ca/en/devices/info/about",
            FizzTV: "https://www.vmedia.ca/en/devices/info/about",
            qrTitle: "Scan the QR code with your mobile device camera",
        },
        parentControl: {
            ratings: {
                rating: "Rating",
                noRestriction: "No restrictions",
                g: "G (Suitable for all ages)",
                pg: "PG (Parental guidance advised)",
                stronglyCautioned: "14+ (Parents strongly cautioned)",
                restricted: "18+ (Not suitable for minors)"
            },
            unlockTimes: {
                unlockTime: "PIN Unlock Time",
                askAlways: "Ask always",
                oneHour: "Once an hour",
                twoHour: "Every 2 hours",
                fourHour: "Every 4 hours"
            },
            reloginTitle: "Please sign in to access Parental Control",
            forgotTitle: `Sign in to your My Account at ${domain} to access your PIN`,
            adultPin: {
                title: "Enter your PIN",
                error: "You have entered the wrong PIN",
                forgot: "Forgot?"
            }
        },
        favorites: {
            save: "Saving has been completed",
            error: "Changes cannot be saved for some reasons",
            search: {
                enterText: "Search for a channel number or name",
                searchFor: "Search for",
                nothingWasFound: "Nothing was found.",
                tryDifferentKeyword: "Please try different keywords.",
            }
        },
        player: {
            autoplay: "Autoplay",
            on: "ON",
            off: "OFF"
        },
        softwareLicense: {
            url: "https://www.freedommobile.ca/en-CA/terms/tv-software-licence-agreement",
        },
        service: {
            text: "Freedom TV service is powered by VMedia. Both Freedom Mobile Inc. and VMedia Inc. are wholly owned subsidiaries of Videotron Ltd., an integrated communications company engaged in television, entertainment, Internet access, wireline telephone and mobile telephone services, based in Montreal, Quebec.",
        },
        help: {
            FizzTV: {
                faqTitle: "FAQ",
                faqDescription: "Find help steps and answers to frequently asked questions.",
                forumTitle: "Forum",
                forumDescription: "Exchange tips and tricks with other Fizz members",
                supportTitle: "Customer Service team",
                supportDescription: "Link in your mobile device to chat with our Customer Service team. To open a chat conversation:",
                visit: "Visit",
                supportSwitch: {
                    firstInstructions: 'Select the type of device you are using.',
                    secondInstructions: 'Scan the QR code.',
                    qrCodeLink: '',
                }
            }
        },
        languages: {
            en: "English",
            fr: "French",
            system: "System",
        },
        clearCache: {
            btnCaption: "Clear cache",
            title: "Storage",
            total: "Total",
            usage: "Usage",
            mb: "MB",
            tooltipeMsg: "Something went wrong. Please try again later.",
        },
    },
    vod: {
        channels: "On Demand Channels",
        newReleasedShows: "Recently Added Shows",
        recommendedShows: "Recommended Shows",
        newReleasedMovies: "Recently Added Movies",
        recommendedMovies: "Recommended Movies",
        detailGenre: "Genre",
        btnWatchingName: "Watch live",
        fizzChannels: "On Demand Channels",
        mostPopular: "Most Popular",
        newReleases: "New Releases",
        all: "All",
        tvShows: "TV Shows",
        movies: "Movies"
    },
    home: {
        recentChannels: "Recent Channels",
        movies: "Movies",
        sports: "Sports",
        kids: "Kids",
        news: "News",
        live: "LIVE",
        exitApp: "Exit application",
        confirmExitApp: "Are you sure want to exit?",
        noInternet: "Network issue",
        checkConnection: "Cannot connect to the server. Please, check your internet connection",
        continueWatching: "Continue Watching",
        fizzMovies: "Live Movies",
        fizzSports: "Live Sports",
        fizzKids: "Live Kids TV",
        fizzNews: "Live News",
        fizzContinueWatching: "Resume Viewing",
        recentlyOnDemand: "Recently Added On-Demand",
        watchAgain: "Watch Again",
        trends: "Trends",
        olympics: "Olympics",
        liveSeries: "Live TV Shows",
    },
    search: {
        youCanSearch: "Start typing to search...",
        nothingWasFound: "Nothing was found.",
        tryDifferentKeyword: "Please try different keywords.",
        searchFor: "Search for",
        liveTv: "Live TV",
        moviesOnDemand: "Movies On Demand",
        tvShowsOnDemand: "TV Shows On Demand",
        moviesOnDemandFizz: "Movies On Demand",
        tvShowsOnDemandFizz: "TV Shows On Demand",
        channels: "Channels",
        castAndCrew: "Cast & Crew",
        enterText: "Search Titles",
    },
    player: {
        contentNotAvailableTitle: "Content Unavailable",
        contentNotAvailableMessage: "Item is unavailable at the moment",
        confirmStopPlayingTitle: "Stop playing",
        confirmStopPlayingMessage: "Are you sure you want to stop playing?",
        retryModalMessage: "The system experienced a little glitch. Please try again.",
        retryModalTryButton: "Try again",
        retryModalCancelButton: "Cancel",

        buffering: "Buffering",

        info: "Description",
        add: "Add to My TV",
        remove: "My TV",
        subtitles: "Subtitles & Audio", 
        play: "Play",
        pause: "Pause",
        rewind: "Rewind",
        fastForward: "Forward",
        reset: "Restart",
        live: "Go to Live",
        skipNext: "Next episode",
        skipPrev: "Previous episode",
        functionUnavailable: "Unfortunately, this function is currently unavailable for this content",
        replay: "Replay",
        programEnded: `Program is ending soon... Switching to LIVE streaming in ${AppConstants.durationForTooltipeMessageProgramEnded} seconds`,
        volume: "Volume",
        channels: "Channels",
        subtitlesOnly: "Subtitles",
        subtitlesOn: "on",
        subtitlesOff: "off",
        back: "Schedule",
        episodes: "Episodes",
        errorStartLiveProgram: "Live cannot be started. You can continue watching or restart the player.",
        errorSwitchChannel: "An error occurred while switching the channel. Please try again later or restart the player.",
        errorSwitchProgram: "An error occurred while switching the program. Please try again later or restart the player.",
        errorSwitchEpisode: "Unable to switch episode. Please try again.",
        errorReconnection: "Connection restored but program update failed. Please restart.",
        tooltips: {
            errorOpeningPlayerPage: "An error occurred while opening the player page. Please try again later.",
            errorStartingChannel: "An error occurred while starting the channel. Please try again later.",
        }
    },
    castPage: {
        born: "Born",
        relatedTitle: "People also search for",
    },
    details: {
        btns: {
            add: "Add to My TV",
            play: "Play",
            resume: "Resume",
            remove: "My TV",
            trailer: "Trailer",
            channel: "Watch options", 
            season: "Select Season",
            goToChannel: "Go to channel",
            watchLive: "Watch Live",
        },
        castNCrew: {
            title: "Cast & Crew"
        },
        relatedContent: {
            title: "More like this"
        },
        season: "Season",
        channelModal: {
            title: "This program is also available on the channels presented below",
        },
        liveSportLabel: {
            live: "live",
            rebroadCast: "rebroadcast",
            upcoming: "upcoming",
        },
        tooltips: {
            errorOpeningDetailsPage: "An error occurred while opening the details page. Please try again later."
        }
    },
    myTv: {
        favoriteChannels: "Favourite Channels",
        favoriteOnDemand: "Favourite On Demand",
        addFavoriteChannels: "Add Favourite Channels",
        seeOnDemands: "See On Demands",
        myWatchList: "My Programs",
        continueWatching: "Continue Watching",
        seeProgramsInGuide: "See Programs in Guide",
    },
    advisory: {
        [Advisory.NR]: "",
        [Advisory.PG1]: "G",
        [Advisory.PG2]: "PG",
        [Advisory.PG3]: "14+",
        [Advisory.PG4]: "18+",
        [Advisory.R]: "18+",
    },
    cards: {
        nowPlaying: "Now Playing",
        todayAt: "Today at",
        tomorrowAt: "Tomorrow at",
        yesterdayAt: "Yesterday at",
        removed: "Removed from favourites",
        at: "at",
    },
    notSupported: {
        text: "Your device is not supported",
    },
    subtitlesModal: {
        title: "Subtitles & Audio",
        subtitle: "Subtitles",
        audio: "Audio",
        english: "English",
        french: "French",
        off: "Off",
        englishDescribedVideo: "English - Described Video",
        descriptiveAudio: "Descriptive audio",
        originalAudio: "Original",
        closedCaption: "Closed Caption",
    },
    guide: {
        favoriteChannels: "Favourites Channels",
        channelFilter: "Channel Filter",
        emptyData: "No content available for selected TV Guide filters",
        emptyDataTitle: "This space is all yours.",
        emptyDataMsg: "Save your favourite channels under My TV to find them easily.",
        emptyDataBtn: "Add channels",
        waiting: "Please wait",
        btnWatch: "Watch live",
        today: "TODAY",
        yesterday: "YESTERDAY",
        tomorrow: "TOMORROW",
        erroreChannelsSegments: "An error occurred. Failed to retrieve the programs. Please try again later.",
        filterTabs: {
            all: 'All',
            subscribed: 'My plan',
            favourites: 'My TV',
            out_of_home: 'Out of home'
        }
    },
    highDefinition: "HD",
    closedCaptions: "CC",
    showAll: "View All",
    cancelButton: "Cancel",
    previewMode: "Guest mode",
    contentUnavailableSingIn: {
        RiverTV: "Content is not available.<br> Please sign into your account",
        VMedia: "Content is not available.<br> Please sign into your account",
        Freedom: "This is a preview account. Please sign in to access your account.<br><br>Not registered with Freedom TV? Sign up now.<br><br>In select areas, and with an eligible Freedom Home Internet plan, you get access to add Freedom TV.<br><br>Stay tuned for areas we’re expanding in!",
        FizzTV: "Content is not available.<br> Please sign into your account"
    },
    reloadModal: {
        title: "Restart application",
        message: "To apply the changes, you need to restart the application.",
        btnConfirm: "Restart Now",
        btnCancel: "Later"
    },
    vizitOne: {
        urlTitle: "Visit:",
        or: "OR",
        qrTitle: "Scan the QR code with your mobile device camera",
    },
    maintenanceModal: {
        title: "Maintenance",
        player: {
            message: "We are under maintenance. Please, be patient. You may continue to watch current playback.",
            btn: "Ok"
        },
        global: {
            message: "We are under maintenance. Please, be patient. We will check availability automatically in",
            btnDisabledMessage: "The next try will be available in",
            btnEnabledMessage: "Try again",
        },
    },
    youtubeError: {
        default: "The trailer is temporarily unavailable. Please try again later."
    },
    fatalError: "An error occurred during application execution. Please click 'Exit Now' and restart the application.",
    chunkError: "An error occurred while loading a module. Please click 'Exit now' and restart the application."
};

export default messages;
